import React, { useState, useEffect } from "react";
import Header from "../include/Header";
import Footer from '../include/Footer';
import ReCAPTCHA from "react-google-recaptcha";
import { Link } from "react-router-dom";
import Select from "../admin2/views/forms/select/Select";
import api from "../../api/axiosInstance";
import API_PATH from "../../api/apiPath";

export default function Contact() {
    const [contactData, setContactData] = useState(null);
    const [captchaValue, setCaptchaValue] = useState(null);

    const [formData, setFormData] = useState({
        firstName: "",
        email: "",
        contactNo: "",
        queryType: "",
        companyName: "",
        message: "",
    });

    useEffect(() => {
        const fetchContactData = async () => {
            try {
                const res = await api.get("/contact-data/get-contacts");
                if (res.data.success && res.data.contacts.length > 0) {
                    setContactData(res.data.contacts[0]);
                }
            } catch (error) {
                console.error("Error fetching contact data:", error);
            }
        };

        fetchContactData();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleCaptcha = (value) => {
        setCaptchaValue(value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Optional: enable captcha if you’re using it
        // if (!captchaValue) {
        //     alert("Please verify that you are not a robot.");
        //     return;
        // }

        try {
            // Send form data to backend API
            const response = await api.post("/mail/contact", formData);

            if (response.data.success) {
                // alert("✅ Message sent successfully!");
                // console.log("Response:", response.data);

                // Reset form after success
                setFormData({
                    firstName: "",
                    email: "",
                    contactNo: "",
                    companyName: "",
                    message: "",
                });
            } else {
                alert("❌ Failed to send message. Please try again later.");
            }
        } catch (error) {
            console.error("Error sending message:", error);
            alert("⚠️ Something went wrong while sending your message.");
        }
    };

    return (
        <div>
            <Header />
            <main>
                {/* ---------- Banner Section ---------- */}
                <section className="leadership-banner position-relative wings-top-section">
                    <img
                        src={
                            contactData
                                ? `${API_PATH}/uploads/contact/${contactData.contact_banner}`
                                : "assets/images/contact-us-banner.png"
                        }
                        alt="Contact Banner"
                        className="img-fluid desktop-banner"
                    />
                    <div className="container-fluid plr">
                        <div className="leadership-banner-caption">
                            <h2>Contact Us
                                <br></br>
                                <span> {contactData?.contact_sub_heading}</span>
                            </h2>
                            <ul className="path-women-empow">
                                <li>
                                    <a href="/">Home</a>
                                </li>
                                <li className="text-white">/</li>
                                <li>
                                    <a href="#">Contact Us</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </section>

                {/* ---------- Query Form Section ---------- */}
                <section className="powering-progress pt-5">
                    <div className="container-fluid plr">
                        <div className="text-center mb-5">
                            <h2 className="section-title">Query Form</h2>
                        </div>

                        <form className="contect-form" onSubmit={handleSubmit}>
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <label className="form-label">Full Name</label>
                                    <input
                                        type="text"
                                        name="firstName"
                                        value={formData.firstName}
                                        onChange={handleChange}
                                        className="form-control"
                                        placeholder="Enter your full name"
                                        required
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Email Address</label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        className="form-control"
                                        placeholder="Enter your email"
                                        required
                                    />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <label className="form-label">Contact No</label>
                                    <input
                                        type="text"
                                        name="contactNo"
                                        value={formData.contactNo}
                                        onChange={handleChange}
                                        className="form-control"
                                        placeholder="Enter contact number"
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Type of Query</label>
                                    <select
                                        name="queryType"
                                        value={formData.queryType}
                                        onChange={handleChange}
                                        className="form-control"
                                    >
                                        <option value="">Select</option>
                                        <option value="General">General</option>
                                        <option value="Business">Business Related</option>
                                        <option value="Career">Career Related</option>
                                        <option value="Investor">Investor Related</option>
                                        <option value="Others">Others</option>
                                    </select>
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-md-8">
                                    <label className="form-label">Remark / Message*</label>
                                    <textarea
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        className="form-control"
                                        placeholder="Enter your message"
                                        rows="4"
                                        required
                                    ></textarea>
                                </div>
                                <div className="col-md-4 d-flex align-items-center">
                                    <ReCAPTCHA
                                        sitekey="6LcPMwUsAAAAALpR4hhZvtCC-ASgL5m5BMyRXi4n"
                                        onChange={handleCaptcha}
                                    />
                                </div>
                            </div>

                            <div className="d-flex justify-content-center contact-btn pb-5 my-5">
                                <button type="submit" className="btn btn-design" style={{ position: "unset" }}>
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </section>

                {/* ---------- Office Location Section ---------- */}
                <section className="powering-progres pb-5 pt-5">
                    <div className="container-fluid plr">
                        <div className="text-center mb-5">
                            <h2 className="section-title">Office Locations</h2>
                        </div>

                        <div className="row">
                            <div className="col-lg-4">
                                <h4>Headquarter</h4>
                                <p>{contactData?.office_main}</p>

                                <h4 className="mt-5">Other</h4>
                                <p>{contactData?.office_other}</p>
                            </div>

                            <div className="col-lg-8">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2974.920644588653!2d77.0848661!3d28.401636099999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d230011ef457b%3A0x65d9e1e2dde48a18!2sDatta%20Power%20Infra%20Pvt%20Ltd!5e1!3m2!1sen!2sin!4v1761893409193!5m2!1sen!2sin"
                                    width="100%"
                                    height="450"
                                    style={{ border: 0 }}
                                    allowFullScreen
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title="Datta Power Infra Pvt Ltd Location"
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    )
}
